/* eslint-disable import/no-cycle */
import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import ReactPlayer from 'react-player';
import { IVideo } from './Videos';

const PlayVideo: React.FC<{
  video: IVideo;
  isOpen: boolean;
  onClose: () => void;
}> = ({ video, isOpen, onClose }) => (
  <Modal size="2xl" isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        <Text>{video.title}</Text>
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody>
        <Flex justifyContent="center">
          <ReactPlayer url={video.url} width="100%" controls />
        </Flex>
        <Text
          fontWeight="400"
          fontSize="16px"
          lineHeight="150%"
          color="text.mediumBlack"
          marginTop="10px"
        >
          {video?.description}
        </Text>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default PlayVideo;
